import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50ca6c67&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=50ca6c67&prod&lang=stylus&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=50ca6c67&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ca6c67",
  null
  
)

export default component.exports